import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";
import "./CommentModal.scss";

type CommentType = {
  id: number;
  comment_date: string;
  role: "Partner" | "Admin";
  comment: string;
};

type Props = {
  open: boolean;
  onClose: () => void;
  activityName: string;
  comments: CommentType[];
  onAddComment: (comment: string) => void;
  onEditComment: (id: number) => void;
  onDeleteComment: (id: number) => void;
  onUpdate: (data:any) => void;
};

const CommentModal: React.FC<Props> = ({
  open,
  onClose,
  activityName,
  comments,
  onAddComment,
  onEditComment,
  onDeleteComment,
  onUpdate,
}) => {
  const [newComment, setNewComment] = useState("");

  const [commentList, setCommentList] = useState(comments || [])
  const [editCommentIndex, setEditCommentIndex] = useState(0);
  const [editOption, setEditOption] = useState(false);

  console.log("comments", comments)

  const handleAddClick = () => {
    let cData = structuredClone(commentList);
    const d=new Date();
    cData.push({
      role: "Admin",
      comment: newComment,
      id: 0,
      comment_date: d.toLocaleDateString('sv-SE')
    })

    setCommentList(cData)
    setNewComment("");
    if (newComment.trim()) {
      //onAddComment(newComment.trim());
      //setNewComment("");
    }
  };


  const deleteCommentFn = (index: number) => {

    let cData = structuredClone(commentList);

    cData.splice(index, 1);
    setCommentList(cData)
  }

  const handleEditClick = () => {
    let cData = structuredClone(commentList);
    cData[editCommentIndex].comment = newComment;
    setCommentList(cData)
    setEditOption(false)
    setNewComment("");
  }

  const callUpdateDataFn=()=>{
    onUpdate(commentList)
    onClose();
  }


  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" className="comment-modal">
      <DialogTitle className="comment-modal-title">
        <span>Comments : {activityName}</span>
        <button className="close-btn" onClick={onClose} aria-label="Close dialog">
          <Iconography icon="xmark" size={IconographySizes.Small} />
        </button>
      </DialogTitle>

      <DialogContent className="comment-modal-content">
        <label htmlFor="new-comment" className="add-comment-label">Add New Comment</label>
        <span className="char-count">{newComment.length}/500</span>
        <div className="textarea-wrapped">
          <textarea
            id="new-comment"
            className="add-comment-textarea"
            placeholder="comment"
            maxLength={500}
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
          />
          <div className="add-comment-footer">
            {editOption ? <button
              className="add-comment-btn"
              onClick={() => { handleEditClick() }}
              disabled={!newComment.trim()}
              aria-label="Add comment"
            >
              Update
            </button> :
              <button
                className="add-comment-btn"
                onClick={() => { handleAddClick() }}
                disabled={!newComment.trim()}
                aria-label="Add comment"
              >
                ADD
              </button>
            }


          </div>
        </div>
        <div className="table-wrapper">
          <table className="comments-table" aria-label="Comments table">
            <thead>
              <tr>
                <th>Date and Time</th>
                <th>Posted by</th>
                <th>Comment</th>
                <th style={{ textAlign: "center", width: 100 }}>Actions</th>
              </tr>
            </thead>

            <tbody>
              {(commentList && commentList.length === 0 || commentList === undefined) ? (
                <tr>
                  <td colSpan={4} style={{ textAlign: "center", padding: "1rem" }}>
                    No comments found
                  </td>
                </tr>
              ) : (
                commentList && commentList.length && commentList.map((c_data: any, index: number) => (
                  <tr key={c_data.id}>
                    <td>{c_data.comment_date}</td>
                    <td>{c_data.role}</td>
                    <td>
                      <div className="comment-text">{c_data.comment}</div>
                    </td>
                    <td width={100}>
                      <button
                        className="icon-btn submit"
                        aria-label="Edit comment"
                        onClick={() => {
                          setNewComment(c_data.comment)
                          setEditCommentIndex(index)
                          setEditOption(true)
                        }
                        }
                      >
                        <Iconography icon="pen" size={IconographySizes.Small} />
                      </button>
                      <button
                        className="icon-btn cancel"
                        aria-label="Delete comment"
                        onClick={() => deleteCommentFn(index)}
                      >
                        <Iconography icon="trashCan" size={IconographySizes.Small} />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </DialogContent>

      <DialogActions className="comment-modal-actions">
        <Button variant="text" onClick={onClose}>
          CANCEL
        </Button>
        <Button variant="contained" onClick={()=>{
          callUpdateDataFn()
        }}>
          UPDATE
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CommentModal;